import { useState, useEffect } from 'react';

/**
 * useWindowWidth — reactive breakpoint detection.
 *
 * Breakpoints (matches NutraShore responsive spec):
 *   Mobile:       < 640px
 *   Tablet:       640–1023px
 *   Desktop:      ≥ 1024px  (no tablet-large distinction needed in logic)
 */
export function useWindowWidth() {
  const [width, setWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1280
  );

  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return {
    width,
    isMobile:  width < 640,
    isTablet:  width >= 640 && width < 1024,
    isDesktop: width >= 1024,
  };
}
